import $api from '../config/api'

export const getSettingsService = async () => {
  const response = await $api.get('/setting')
  return response.data
}

export const updateSettingsService = async (reqData: Settings) => {
  const response = await $api.put('/setting', reqData)
  return response
}
